export const DASHBOARD_HERO_IMAGES = [
    '249882211.jpg',
    '263954561.jpg',
    '320533161.jpg',
    '355429851.jpg',
    '505100201.jpg',
    '548843411.jpg',
    '610764843-1.jpg',
    '637894271.jpg'
];

export const getRandomDashboardHeroImage = () => {
    const image = DASHBOARD_HERO_IMAGES[Math.floor(Math.random() * DASHBOARD_HERO_IMAGES.length)];
    return `/assets/dashboard-hero/optimized/${image}`;
}
